import script from "./BaseRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadio.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadio.vue?vue&type=style&index=0&id=305af775&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305af775"]])

export default __exports__